import React from 'react'

import './user-activity-filter.scss'

const UserActivityFilter = (props) => {
  if (!props.user) return null
  const {
    user: { username },
    handleClear,
  } = props
  return (
    <>
      {username && (
        <div className='user-activity-filter'>
          <span>
            {username} {I18n.t('react.shared.comminity.activity')}
          </span>
          <i className='fas fa-times' onClick={handleClear} />
        </div>
      )}
    </>
  )
}

export default UserActivityFilter
